const schedulerProvider = "VITE_SCHEDULER_PROVIDER_VALUE";
const schedulerUrl = "VITE_SCHEDULER_URL_VALUE";
const leadFormAction = "VITE_LEAD_FORM_ACTION_VALUE";
const leadFormMethod = "VITE_LEAD_FORM_METHOD_VALUE" || "POST";

const hasRealValue = (value) => value && !value.endsWith("_VALUE");
const localeStorageKey = "fkandpartner_locale";
const localeCookieKey = "fkandpartner_locale";

function getCookie(name) {
  return document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${name}=`))
    ?.split("=")[1];
}

function setLocalePreference(locale) {
  localStorage.setItem(localeStorageKey, locale);
  document.cookie = `${localeCookieKey}=${locale}; path=/; max-age=31536000; SameSite=Lax`;
}

function getAlternateUrl(locale) {
  const link = document.querySelector(`link[rel="alternate"][hreflang="${locale}"]`);
  if (!link) {
    return "";
  }

  try {
    return new URL(link.href, window.location.origin).pathname;
  } catch {
    return link.getAttribute("href") || "";
  }
}

function detectLocale() {
  const stored = localStorage.getItem(localeStorageKey) || getCookie(localeCookieKey);
  if (stored === "fr" || stored === "en") {
    return { locale: stored, explicit: true };
  }

  const browserLocales = navigator.languages || [navigator.language || "fr"];
  const browserLocale = browserLocales.find(Boolean)?.toLowerCase() || "fr";
  return { locale: browserLocale.startsWith("en") ? "en" : "fr", explicit: false };
}

document.addEventListener("DOMContentLoaded", () => {
  const currentLocale = document.body.dataset.locale || document.documentElement.lang || "fr";
  const detected = detectLocale();

  if (detected.locale !== currentLocale) {
    const targetPath = getAlternateUrl(detected.locale);
    if (targetPath && window.location.pathname !== targetPath) {
      if (!detected.explicit) {
        setLocalePreference(detected.locale);
      }
      window.location.replace(targetPath);
      return;
    }
  }

  document.querySelectorAll("[data-locale-link]").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const nextLocale = link.getAttribute("data-locale-link");
      if (!nextLocale || nextLocale === currentLocale) {
        return;
      }

      setLocalePreference(nextLocale);
      const targetPath = getAlternateUrl(nextLocale) || link.getAttribute("href");
      if (targetPath) {
        window.location.href = targetPath;
      }
    });
  });

  const form = document.querySelector("[data-lead-form]");
  const note = document.querySelector("[data-form-note]");

  if (!form) {
    return;
  }

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const formData = new FormData(form);

    if (hasRealValue(leadFormAction)) {
      try {
        const payload = Object.fromEntries(formData.entries());
        const response = await fetch(leadFormAction, {
          method: hasRealValue(leadFormMethod) ? leadFormMethod : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`Lead capture failed with ${response.status}`);
        }
      } catch (error) {
        console.error(error);
        if (note) {
          note.textContent =
            "Le formulaire n'a pas pu être transmis. Vous pouvez quand même réserver votre rendez-vous.";
        }
      }
    }

    if (hasRealValue(schedulerUrl)) {
      const target = new URL(schedulerUrl, window.location.origin);
      target.searchParams.set("source", "fk-web");
      target.searchParams.set("provider", hasRealValue(schedulerProvider) ? schedulerProvider : "scheduler");
      target.searchParams.set("name", String(formData.get("name") || ""));
      target.searchParams.set("email", String(formData.get("email") || ""));
      window.location.href = target.toString();
      return;
    }

    if (note) {
      note.textContent =
        "Aucune URL de calendrier n'est encore configurée. Renseignez VITE_SCHEDULER_URL pour activer la réservation.";
    }
  });
});
